
/* styles */
require("!!./../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter?id=data-v-e470f43a&scoped=true!./../../node_modules/vue-loader/lib/selector?type=styles&index=0!./StsFooter.vue")

var Component = require("!./../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../node_modules/vue-loader/lib/selector?type=script&index=0!./StsFooter.vue"),
  /* template */
  require("!!./../../node_modules/vue-loader/lib/template-compiler?id=data-v-e470f43a!./../../node_modules/vue-loader/lib/selector?type=template&index=0!./StsFooter.vue"),
  /* scopeId */
  "data-v-e470f43a",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/StsFooter.vue
// module id = 458
// module chunks = 1